import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { Field } from 'src/app/models/field/field.model';
import { AppConfigService } from 'src/app/services/app-config.service';
import { PagingResponse } from '@models/paging-response.model';

@Injectable({
  providedIn: 'root'
})
export class BuiltInFieldsService implements OnDestroy {

  private fieldListSubject = new ReplaySubject<PagingResponse<Field>>(1);
  private fieldCache = new Map<string, Field>();
  private productionSortFieldSubject = new BehaviorSubject <Field[]>([]);

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.refreshFields();
  }

  ngOnDestroy() {
    this.fieldListSubject.complete();
  }

  public getFields(): Observable<PagingResponse<Field>> {
    return this.fieldListSubject.asObservable();
  }
  
  public getField(fieldId: string) {
    return this.fieldCache.get(fieldId);
  }

  public getProductionSortFields(): Observable<Field[]> {
    return this.productionSortFieldSubject.asObservable();
  }

  private setFields(fields: PagingResponse<Field>): void {
    this.fieldListSubject.next(fields);
    this.fieldCache.clear();
    fields.value.forEach(field => this.fieldCache.set(field.fieldId, field));
    // This works as isproductionsortoption is a subset of ispartofdisplay
    this.productionSortFieldSubject.next(fields.value.filter(f => f.isProductionSortOption)); 
  }

  private refreshFields(): void {
    const url = `${this.appConfigService.getConfig().webApi}/api2/builtinfields?$filter=ispartofdisplay eq true`;
    this.http.get<PagingResponse<Field>>(url).subscribe((fields: PagingResponse<Field>) => {
      this.setFields(fields);
    });
  }

}
